import { borderStyle, borderRadiusStyle,boxShadow,dimensions } from "@vayu-blocks/global";
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export const DynamicStyleIcon = ({ attributes, isHovered }) => {
    const getView = VayuBlocksDevice();

    // Precompute values to avoid redundant calls
    const borderHover = attributes?.iconsBorderHover;
    const border = attributes?.iconsBorder;
    const radiusHover = attributes?.iconsRadiusHover;
    const radius = attributes?.iconsRadius;
    const shadowHover = attributes?.iconsDropShadowHover;
    const shadow = attributes?.iconsDropShadow;

    const borderStyleC = borderHover?.[getView] ? borderStyle(borderHover, getView, border) : borderStyle(border, getView);
    const borderRadiusStyleC = radiusHover?.[getView] ? borderRadiusStyle(radiusHover, getView, attributes.iconsRadius) : borderRadiusStyle(radius, getView);
    const boxShadowC = shadowHover?.[getView] ? boxShadow(shadowHover, getView) : boxShadow(attributes.iconsDropShadow, getView);

    return isHovered === 'normal'
        ? {
            padding: dimensions(attributes.iconpadding, getView),
            margin: dimensions(attributes.iconmargin, getView),
            ...boxShadow(shadow, getView),
            ...borderStyle(border, getView),
            ...borderRadiusStyle(radius, getView),
        }
        : {
            ...boxShadowC,
            ...borderStyleC,
            ...borderRadiusStyleC,
            padding: dimensions(attributes.iconpadding, getView),
            margin: dimensions(attributes.iconmargin, getView),
        };
};

export  const DynamicmainStyleIcon = ({ attributes, isHovered }) => {

    const getView = VayuBlocksDevice();
    
    const radiusHover = attributes?.iconsRadiusHover;
    const radius = attributes?.iconsRadius;

    const borderRadiusStyleC = radiusHover?.[getView] ? borderRadiusStyle(radiusHover, getView, attributes.iconsRadius) : borderRadiusStyle(radius, getView);

    return isHovered === 'normal'
        ? {
            ...borderRadiusStyle(radius, getView),
        }
        : {
            ...borderRadiusStyleC,
    };
};

export const captionmainstyles = ({ attributes, istextHovered }) => {
	const getView = VayuBlocksDevice();

	const backgroundColor =
		istextHovered === 'normal'
			? attributes.textbgcolor
			: attributes.textbgcolorhvr;

    const color =
		istextHovered === 'normal'
			? attributes.textcolor
			: attributes.textcolorhover;


	const style = {};

	if (backgroundColor) {
		style.background = backgroundColor;
	}

    if (color) {
		style.color = color;
	}

	style.top= attributes.textx;
    style.position= 'absolute';
    style.left= attributes.texty;

	return style;
};
